import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, FlowService } from '__services';

@Component({
  selector: 'app-flow-journey-panel',
  templateUrl: './flow-journey-panel.component.html',
  styleUrls: ['./flow-journey-panel.component.scss'],
})
export class FlowJourneyPanelComponent implements OnInit {
  items: any;
  flowId: any;
  isPatchingNotification: boolean = false; 
  @Input() categories: any = [];
  @Input() readOnly: boolean = true;
  @Input() category_ids: any = [];
  @Input() flowCancelReason;
  @Input() notification;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChangeNotification: EventEmitter<any> = new EventEmitter<any>();

  @Input() set data(value) {
    if (value) {
      this.flowId = value.flowId;
      const { items, indexStepSelected } = value;
      if (items?.length) {
        items.forEach((e, i) => {
          e.selected = i === this.prevSelected;
          e.index = i + 1;
          // e['statusColor'] = 0;
          e.step_num = i + 1;
          if (indexStepSelected >= 0) {
            e.selected = i === indexStepSelected;
            this.prevSelected = indexStepSelected;
          }

          if (items[0].name === 'Safety Data Sheet') {
            e.step_num = i;
          }
        });
        this.items = items;
        if (indexStepSelected >= 0) {
          this.configObj.itemSelected = this.items[indexStepSelected];
        } else {
          this.configObj.itemSelected = this.items[0];
        }
      }
    }
  }

  prevSelected = 0;
  selectedItem: any;

  configObj = {
    title: 'Steps',
    height: 60,
    expanded: true,
    itemSelected: null,
    position: 'right',
  };

  constructor(
    private trans: TranslateService,
    private flowService: FlowService
  ) {}

  ngOnInit(): void {}

  onSelected(value, index): void {
    if (this.prevSelected === index) {
      return;
    }
    this.selectedItem = Object.assign(value, { index: index + 1 });
    this.valueChanged.emit(this.selectedItem);
  }

  onClickNotification() {
    if (!this.flowId || !this.notification) return;
    if (this.isPatchingNotification) return;
    this.isPatchingNotification = true;

    this.flowService.patchFlowNotification(this.flowId).subscribe({
      next: () => {
        this.notification.enable = !this.notification.enable;
        this.onChangeNotification.emit(this.notification.enable);
      },
      complete: () => {
        this.isPatchingNotification = false;
      },
    });
  }

  onChangeCategory(event) {
    this.flowService.patchFlowCategory(this.flowId, { category_ids: this.category_ids }).subscribe();
  }
}
